export {PaginationStripe} from './pagination-stripe/pagination-stripe.component';
export {Pagination} from './pagination/pagination.component';
export {ClientPaginationData} from './client-pagination-data';
export {setMaxPaginationSize} from './utils';
export {PaginationRangeTypes} from './typedef';

export {SIZES, ALL_RESULTS} from './pagination-stripe/constants';

export type {PaginationChangeHandler} from './pagination-stripe/pagination-stripe.component';
export type {OnPaginationChange} from './pagination-stripe/pagination-stripe.component';
export type {PaginationParams, PaginationRangeType} from './typedef';
export type {ClientPaginationType} from './client-pagination-data';
export type {PaginationStripeProps} from './pagination-stripe/pagination-stripe.component';
export type {PaginationProps} from './pagination/pagination.component';
